import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow_left_blue.svg'
import _imports_1 from '@/assets/img/feven_move.svg'
import _imports_2 from '@/assets/img/attention_rounded_blue.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-784e9fc0")

_pushScopeId("data-v-784e9fc0")
const _hoisted_1 = { class: "modal full bg_white" }
const _hoisted_2 = { class: "modal_header" }
const _hoisted_3 = { class: "modal_body" }
const _hoisted_4 = { class: "d-flex mb-5" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "feven_move",
  src: _imports_1
}, null, -1)
const _hoisted_6 = { class: "position_container" }
const _hoisted_7 = {
  key: 0,
  class: "attention",
  src: _imports_2
}
const _hoisted_8 = { class: "fev_text1 fw_800 mt-5 mb-3" }
const _hoisted_9 = { class: "mt-5 w-100 trova_piu_vicino" }
const _hoisted_10 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "attention",
  src: _imports_2
}
const _hoisted_12 = { class: "fev_text1 fw_800 mt-2 mb-3" }
const _hoisted_13 = { class: "modal_footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_feven = _resolveComponent("header-feven")
  const _component_localized_text = _resolveComponent("localized-text")
  const _component_form_field = _resolveComponent("form-field")
  const _component_toggle_switch = _resolveComponent("toggle-switch")
  const _component_MultiRangeSlider = _resolveComponent("MultiRangeSlider")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_header_feven, { white: false }, {
        left: _withId(() => [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        class: "fev_text5 fw_600 mb-3",
        localizedKey: "app_Mostrami",
        text: "Mostrami"
      }),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.consts.genderList, (gend) => {
          return (_openBlock(), _createBlock("div", {
            class: ["filter_button", {active : gend.identifier == _ctx.localFilter.lookingFor}],
            onClick: ($event: any) => (_ctx.setGender(gend.identifier))
          }, [
            _createVNode("span", null, _toDisplayString(gend.text), 1)
          ], 10, ["onClick"]))
        }), 256))
      ]),
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        (_ctx.localFilter.currentPosition.addressFixed)
          ? (_openBlock(), _createBlock("img", _hoisted_7))
          : _createCommentVNode("", true),
        _createVNode(_component_form_field, {
          type: "google-get-list",
          userAddress: _ctx.localFilter.currentPosition,
          modelValue: _ctx.googleFilterAddressVM,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.googleFilterAddressVM = $event)),
          placeholderKey: "app_Cerca",
          placeholderValue: "Cerca"
        }, null, 8, ["userAddress", "modelValue"])
      ]),
      _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$filters.kmFromMeters(_ctx.localFilter.meters)), 1),
      _createVNode(_component_form_field, {
        class: "position",
        type: "range",
        min: _ctx.locationSettings.min,
        max: _ctx.locationSettings.max,
        step: _ctx.locationSettings.step,
        modelValue: _ctx.localFilter.meters,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.localFilter.meters = $event))
      }, null, 8, ["min", "max", "step", "modelValue"]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_TrovaLaPersonaPiùVicinaAMeAncheSeFuoriDalMioRange",
            text: "Trova la persona più vicina a me anche se fuori dal mio range",
            class: "me-3 fev_text6 fw_700 blue"
          }),
          _createVNode(_component_toggle_switch, {
            modelValue: _ctx.localFilter.findUserOutsideMyRange,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.localFilter.findUserOutsideMyRange = $event)),
            activeText: _ctx.$localizationService.getLocalizedValue('app_Si', 'Si'),
            inactiveText: _ctx.$localizationService.getLocalizedValue('app_No', 'No')
          }, null, 8, ["modelValue", "activeText", "inactiveText"]),
          (_ctx.localFilter.findUserOutsideMyRange)
            ? (_openBlock(), _createBlock("img", _hoisted_11))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_localized_text, {
        class: "fev_text5 fw_600 mt-5 mb-3",
        localizedKey: "app_AgeRange",
        text: "Age Range"
      }),
      _createVNode("span", _hoisted_12, _toDisplayString(_ctx.localFilter.ageRange.minAge) + " - " + _toDisplayString(_ctx.getMaxRange), 1),
      _createVNode(_component_MultiRangeSlider, {
        min: _ctx.ageSettings.min,
        max: _ctx.ageSettings.maxVisible,
        step: _ctx.ageSettings.step,
        ruler: false,
        label: false,
        minValue: _ctx.localFilter.ageRange.minAge,
        maxValue: _ctx.localFilter.ageRange.maxAge,
        onInput: _ctx.UpdateValues
      }, null, 8, ["min", "max", "step", "minValue", "maxValue", "onInput"])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("button", {
        class: "fev_button bg_brand",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_ApplicaFiltri",
          text: "Applica Filtri"
        })
      ])
    ])
  ]))
})